import script from "./CustomDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./CustomDropdown.vue?vue&type=style&index=0&id=585d66d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585d66d0"]])

export default __exports__